import { render } from "./ProfileCarousel.vue?vue&type=template&id=e8fe0aec"
import script from "./ProfileCarousel.vue?vue&type=script&lang=js"
export * from "./ProfileCarousel.vue?vue&type=script&lang=js"

import "./ProfileCarousel.vue?vue&type=style&index=0&id=e8fe0aec&lang=css"
script.render = render

export default script